import { LitElement, html, utils } from '@hh/global.js'

class HHProductCardAddon extends LitElement {
  static properties = {
    carouselClass: {
      type: String,
      attribute: 'data-product-carousel',
    },
  }

  constructor() {
    super()

    this.carouselClass = ''
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleCarousel()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleCarousel() {
    const splideExtension = window.splide.Extensions

    this.splide = new Splide(`.${this.carouselClass}`, {
      arrows: false,
      pagination: true,
      perPage: 1,
      mediaQuery: 'min',
    }).mount(splideExtension)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('hh-product-card-addon', HHProductCardAddon)
